import {ArrowPositionType} from '../types';

const padding = 2;
export const getTooltipPosition = (
  triggerRect: undefined | Pick<DOMRect, 'x' | 'y' | 'width' | 'height'>,
  arrowPosition: ArrowPositionType,
  tooltipWidth: number,
): {left: number | undefined; top: number | undefined} => {
  switch (arrowPosition) {
    case 'TopRight':
      return {
        left:
          triggerRect && triggerRect.x - tooltipWidth + triggerRect.width / 2,
        top: triggerRect && triggerRect.y + triggerRect.height + padding,
      };
    case 'TopCenter':
      return {
        left: triggerRect && triggerRect.x - tooltipWidth / 2,
        top: triggerRect && triggerRect.y + triggerRect.height + padding,
      };
    case 'TopLeft':
      return {
        left: triggerRect && triggerRect.x,
        top: triggerRect && triggerRect.y + triggerRect.height + padding,
      };
    case 'LeftTop':
      return {
        left: triggerRect && triggerRect.x + triggerRect.width + padding,
        top: triggerRect && triggerRect.y,
      };
    case 'LeftCenter':
      return {
        left: triggerRect && triggerRect.x + triggerRect.width + padding,
        top: triggerRect && triggerRect.y - triggerRect.height / 3,
      };
    case 'LeftBottom':
      return {
        left: triggerRect && triggerRect.x + triggerRect.width + padding,
        top: triggerRect && triggerRect.y - triggerRect.height,
      };
    case 'RightTop':
      return {
        left:
          triggerRect &&
          triggerRect.x - triggerRect.width - tooltipWidth - padding,
        top: triggerRect && triggerRect.y,
      };
    case 'RightCenter':
      return {
        left:
          triggerRect &&
          triggerRect.x - triggerRect.width - tooltipWidth - padding,
        top: triggerRect && triggerRect.y - triggerRect.height / 3,
      };
    case 'RightBottom':
      return {
        left:
          triggerRect &&
          triggerRect.x - triggerRect.width - tooltipWidth - padding,
        top: triggerRect && triggerRect.y - triggerRect.height,
      };
    case 'BottomRight':
      return {
        left:
          triggerRect && triggerRect.x - tooltipWidth + triggerRect.width / 2,
        top: triggerRect && triggerRect.y - triggerRect.height * 2.5 - padding,
      };
    case 'BottomCenter':
      return {
        left: triggerRect && triggerRect.x - tooltipWidth / 2,
        top: triggerRect && triggerRect.y - triggerRect.height * 2.5 - padding,
      };
    case 'BottomLeft':
      return {
        left: triggerRect && triggerRect && triggerRect.x,
        top: triggerRect && triggerRect.y - triggerRect.height * 2.5 - padding,
      };
    default:
      return {
        left: undefined,
        top: undefined,
      };
  }
};
